module.exports = __webpack_public_path__ + "img/twitter.07f6d46f.svg";